import { TeamsProvider } from '@microsoft/mgt';
import * as microsoftTeams from '@microsoft/teams-js';
import { UserAgentApplication } from 'msal';
import React, { useEffect } from 'react';
import {
  centeredFull,
  defaultFont,
  themedText,
} from '../../../styles/SharedStyles';
import { LoadingPage } from '../../Shared';
import { useThemeContext } from '../../../context';
import './GraphAuth.scss';

export function GraphAuth(): JSX.Element {
  const theme = useThemeContext();

  useEffect(() => {
    async function handleAuth() {
      await TeamsProvider.handleAuth();
    }
    TeamsProvider.microsoftTeamsLib = microsoftTeams;
    // Hack to fix issue with the '@microsoft/mgt' NPM package.
    // The issue is this function is used to check if the redirect URL has a hash which indicates that the login needs to redirect again.
    // The problem is the Teams Provider is calling it off of the prototype function meaning the logger is not defined resulting in an error.
    // Our redirect URL will never have a hash so this function is not needed and this fix effectively stops it from being called fixing the bug.
    UserAgentApplication.prototype.urlContainsHash = function (hash) {
      return false;
    };

    handleAuth().catch(error => console.error(error));
  }, []);

  useEffect(() => {
    // `href` will include a hash after being redirected from login, for both successful and unsuccessful attempts.
    // However, after a success, the pop-up will automatically close.
    if (window.location.href.includes('#')) {
      // If failure, close the window.
      setTimeout(window.close, 10000);
    }
  }, [window.location.href]);

  return (
    <div
      className='graph-login-container'
      style={{ ...defaultFont, ...centeredFull, ...themedText(theme) }}
    >
      <LoadingPage text='Connecting to OneDrive...' fullscreen />
    </div>
  );
}
